const PAYMENT_LINK_PREFIX = "payment-link:";
export const PAYMENT_LINK_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export const PAYMENT_RESULT_BASE_PATHS = {
    onboarding: "/onboarding/payment-result",
    my_plan: "/app/plan/payment-result"
};

const storageKey = (invoiceId) => `${PAYMENT_LINK_PREFIX}${invoiceId}`;

export const savePaymentLink = (invoiceId, url) => {
    try {
        window.sessionStorage.setItem(
            storageKey(invoiceId),
            JSON.stringify({ url, savedAt: Date.now() })
        );
    } catch {
        // Sin sessionStorage se pedirá un link nuevo al retomar el pago.
    }
};

export const getPaymentLink = (invoiceId) => {
    try {
        const raw = window.sessionStorage.getItem(storageKey(invoiceId));
        if (!raw) return null;
        const link = JSON.parse(raw);
        if (!link || typeof link.url !== "string" || !link.url) return null;
        return { url: link.url, savedAt: Number(link.savedAt) || 0 };
    } catch {
        return null;
    }
};

export const isPaymentLinkFresh = (link, now = Date.now()) =>
    !!link && now - link.savedAt < PAYMENT_LINK_MAX_AGE_MS;

export const buildPaymentOpeningRoute = (source, invoiceId) => ({
    path: `${
        PAYMENT_RESULT_BASE_PATHS[source] || PAYMENT_RESULT_BASE_PATHS.my_plan
    }/${invoiceId}`,
    query: { mode: "opening" }
});
